import type { Sport } from '#src/__generated__/globalTypes.ts';

import {
  findLatestCardSetConfig,
  getCollectionBackground,
  getCollectionBackgroundUrl,
} from './index.ts';

// Hook wrappers around the plain card-set lookup functions.
//
// These exist so call sites depend on a hook, not a module-level function.

export const useFindLatestCardSetConfig = () => (sport: Sport) =>
  findLatestCardSetConfig(sport);

export const useGetCollectionBackground =
  () => (setSlug: Nullable<string>, teamSlug: Nullable<string>) =>
    getCollectionBackground(setSlug, teamSlug);

export const useGetCollectionBackgroundUrl =
  () => (setSlug: Nullable<string>, teamSlug: Nullable<string>) =>
    getCollectionBackgroundUrl(setSlug, teamSlug);
